import styled from "@emotion/styled";
import { noop } from "lodash";
import { DOMAttributes, FC } from "react";

import { ChevronRight } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  count: number;
  index: number;
  name: string;
  onClick?: DOMAttributes<HTMLDivElement>["onClick"];
  onMouseDown?: DOMAttributes<HTMLDivElement>["onMouseDown"];
  onMouseEnter: DOMAttributes<HTMLDivElement>["onMouseEnter"];
}

export const CannedResponseTagItem: FC<IProps> = ({
  count,
  index,
  name,
  onMouseEnter,
  onMouseDown = noop,
  onClick = noop,
}) => (
  <Item
    data-testid={`shortcut-item-${name}`}
    onMouseDown={onMouseDown}
    onMouseEnter={onMouseEnter}
    onClick={onClick}
    data-index={index}
  >
    <CannedResponseName data-testid="shortcut-name">{name}</CannedResponseName>
    <CannedResponseCount bold data-testid="canned-responses-count">
      {count}
    </CannedResponseCount>
    <Button
      kind="plain"
      size="xcompact"
      icon={<Icon source={ChevronRight} customColor={withVar(DesignToken.ContentBasicSecondary)} />}
    />
  </Item>
);

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 360px;
  min-width: 90px;
  gap: var(${SpacingToken.Spacing2});
  padding: 6px 6px 6px var(${SpacingToken.Spacing3});
  border-radius: var(${RadiusToken.Radius3});
  cursor: pointer;

  &:hover,
  &.focused {
    background-color: ${withVar(DesignToken.SurfacePrimaryHover)};
  }
`;

const CannedResponseName = styled(Text)`
  padding-top: 1px;
  max-width: 300px;
  overflow-wrap: break-word;
`;

const CannedResponseCount = styled(Text)`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  margin-left: auto;
  padding-top: 1px;
`;
